import { Component } from "../core/Component";
import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";

export class DestroyOffscreen extends Component {
	
	scene: GameScene;
	left: boolean;
	right: boolean;
	offset = 300;

	constructor(obj: GameObject, left: boolean, right: boolean, offset = 300) {
		super(obj);
		this.left = left;
		this.right = right;
		this.offset = offset;
	}

	public preRender(): void {
		const obj = this.obj;
		
		if (this.left) {
			if (obj.x + obj.width + this.offset < this.scene.cameraController.leftBound) obj.destroy();
		}
		if (this.right) {
			if (obj.x - obj.width - this.offset > this.scene.cameraController.rightBound) obj.destroy();
		}
	}

}